//日期时间函数--41个
export const DateTimeFunc = [
  {
    "key": "DayDifference",
    "name": "天數差",
    "params": [
      {
        "key": "date1",
        "name": "時間一",
        "type": "obj"
      },
      {
        "key": "date2",
        "name": "時間二",
        "type": "obj"
      },
    ],
    "description": `【功能】計算兩個時間的天數差，計算時以年月日為准，自動忽略時分秒。時間一若早於時間二，返回正數； 若晚於時間二，返回負數
    【參數】
        【date1】時間一
        【date2】時間二
    【返回值】兩個日期的天數差
    【示例】
        【示例一】天數差("2024-01-01","2024-01-11")
        【返回值】10
        【示例一】天數差("2024-01-11","2024-01-01")
        【返回值】-10`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "DateTimeAddDays",
    "name": "增加天數",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      },
      {
        "key": "value",
        "name": "增加天數",
        "type": "int"
      }
    ],
    "description": `【功能】：在指定日期時間上增加指定天數\n【返回值類型】：日期時間(DateTime)\n【示例】：增加天數("2019-01-30T10:00:00+08:00",2)【返回值】:2019-02-01T10:00+08:00`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "DateTimeAddYears",
    "name": "增加年數",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      },
      {
        "key": "value",
        "name": "增加年數",
        "type": "int"
      }
    ],
    "description": `【功能】：在指定日期時間上增加指定年數\n【返回值類型】：日期時間(DateTime)\n【示例】：增加年數("2019-01-30T10:00:00+08:00",2)【返回值】:2021-01-30T10:00+08:00`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "DateTimeAddMonths",
    "name": "增加月數",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      },
      {
        "key": "value",
        "name": "增加月數",
        "type": "int"
      }
    ],
    "description": `【功能】：在指定日期時間上增加指定的月數\n【返回值類型】：日期時間(DateTime)\n【示例】：增加月數("2019-01-30T10:00:00+08:00",1)【返回值】:2019-02-28T10:00+08:00`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "GetFirstDayOfMonth",
    "name": "日期所在月第一天",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：獲取指定日期時間所在月的第一天的日期\n【返回值類型】：日期時間(DateTime)\n【示例】：日期所在月第一天("2019-01-30T10:00:00+08:00")【返回值】:2019-01-01`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "GetLastDayOfMonth",
    "name": "日期所在月最後一天",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：獲取指定日期時間所在月的最後一天的日期\n【返回值類型】：日期時間(DateTime)\n【示例】：日期所在月最後一天("2019-01-30T10:00:00+08:00")【返回值】:2019-01-31`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "GetDateTimeNow",
    "name": "當前日期時間",
    "params": [],
    "description": `【功能】：獲取當前的日期時間\n【返回值類型】：日期時間(DateTime)\n【示例】：當前日期時間()【返回值】:2019-01-30T12:00:00.000+08:00`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "CompareDate",
    "name": "比較兩個時間",
    "params": [
      {
        "key": "str1",
        "name": "日期時間1",
        "type": "string"
      },
      {
        "key": "str2",
        "name": "日期時間2",
        "type": "string"
      }
    ],
    "description": `【功能】：比較兩個時間值，並返回一個整數\n【返回值類型】：數值(int32)日期1早於日期2，返回-1;日期1等於日期2，返回0;日期1晚於日期2，返回1\n【示例】：比較兩個時間("2019-01-30T10:00:00+08:00","2019-02-01T10:00:00+08:00")【返回值】：-1`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "FormatDate",
    "name": "格式化當前日期",
    "params": [
      {
        "key": "format",
        "name": "格式串",
        "type": "string"
      }
    ],
    "description": `【功能】：使用指定的格式將當前日期時間值轉換為其等效的字符串表示形式\n【返回值類型】：字符串(String)\n【示例】：格式化當前日期("yyyy-MM-dd HH:mm:ss")【返回值】："2019-01-30 01:00:00"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "FormatDefineDate",
    "name": "格式化指定日期",
    "params": [
      {
        "key": "format",
        "name": "格式串",
        "type": "string"
      },
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：使用指定的格式將指定的日期時間值轉換為其等效的字符串表示形式\n【返回值類型】：字符串(String)\n【示例】：格式化指定日期("yyyy-MM-dd HH:mm:ss","2019-01-30 01:00:00")【返回值】："2019-01-30 01:00:00"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "Today",
    "name": "今天",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：返回指定日期的今天，格式為"yyyy-MM-dd"形式，無參數則默認返回當前日期的今天\n【返回值類型】：字符串(String)\n【示例】：今天("2019-01-30T10:00:00+08:00")【返回值】："2019-01-30"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "Yesterday",
    "name": "昨天",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：返回指定日期的昨天，格式為"yyyy-MM-dd"形式，無參數則默認返回當前日期的昨天\n【返回值類型】：字符串(String)\n【示例】：昨天("2019-01-30T10:00:00+08:00")【返回值】："2019-01-29"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "Tomorrow",
    "name": "明天",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：返回指定日期的明天，格式為"yyyy-MM-dd"形式，無參數則默認返回當前日期的明天\n【返回值類型】：字符串(String)\n【示例】：明天("2019-01-30T10:00:00+08:00")【返回值】："2019-01-31"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ThisYear",
    "name": "本年",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：返回指定日期的本年，格式為"yyyy"形式，無參數則默認返回當前日期的本年\n【返回值類型】：字符串(String)\n【示例】：本年("2019-01-30T10:00:00+08:00")【返回值】："2019"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "LastYear",
    "name": "去年",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：返回指定日期的去年，格式為"yyyy"形式，無參數則默認返回當前日期的去年\n【返回值類型】：字符串(String)\n【示例】：去年("2019-01-30T10:00:00+08:00")【返回值】："2018"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "NextYear",
    "name": "明年",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：返回指定日期的明年，格式為"yyyy"形式，無參數則默認返回當前日期的明年\n【返回值類型】：字符串(String)\n【示例】：明年("2019-01-30T01:00:00+08:00")【返回值】："2020"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ThisMonth",
    "name": "本月",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：返回指定日期的本月，格式為"MM"形式，無參數則默認返回當前日期的本月\n【返回值類型】：字符串(String)\n【示例】：本月("2019-01-30T01:00:00+08:00")【返回值】："1"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "LastMonth",
    "name": "上月",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：返回指定日期的上月，格式為"MM"形式，無參數則默認返回當前日期的上月\n【返回值類型】：字符串(String)\n【示例】：上月("2019-02-30 01:00:00")【返回值】："1"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "NextMonth",
    "name": "下月",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：返回指定日期的下月，格式為"MM"形式，無參數則默認返回當前日期的下月\n【返回值類型】：字符串(String)\n【示例】：下月("2019-01-30T01:00:00+08:00")【返回值】："2"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ThisWeek",
    "name": "本週",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：返回指定日期在本年的第幾週，格式為"ww"形式，無參數則默認返回當前日期在本年的第幾週\n【返回值類型】：字符串(String)\n【示例】：本週("2019-01-30T01:00:00+08:00")【返回值】："5"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "LastWeek",
    "name": "上週",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：返回指定日期的上週，格式為"ww"形式，無參數則默認返回當前日期的上週\n【返回值類型】：字符串(String)\n【示例】：上週("2019-01-30T01:00:00+08:00")【返回值】："4"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "NextWeek",
    "name": "下週",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：返回指定日期的下週，格式為"ww"形式，無參數則默認返回當前日期的下週\n【返回值類型】：字符串(String)\n【示例】：下週("2019-01-30T01:00:00+08:00")【返回值】："6"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "DayOfWeek",
    "name": "星期幾",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：返回指定日期是本週的星期幾，格式為"n"，無參數則默認返回當前日期是本週的星期幾\n【返回值類型】：字符串(String)\n【示例】：星期幾("2019-01-30T01:00:00+08:00")【返回值】："3"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "FirstDayOfWeek",
    "name": "本週第一天",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：返回指定日期的本週第一天，格式為"yyyy-MM-dd"，無參數則默認返回當前日期的本週第一天\n【返回值類型】：字符串(String)\n【示例】：本週第一天("2019-01-30T01:00:00+08:00")【返回值】："2019-01-28"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "LastDayOfWeek",
    "name": "本週最後一天",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：返回指定日期的本週最後一天，格式為"yyyy-MM-dd"，無參數則默認返回當前日期的本週第一天\n【返回值類型】：字符串(String)\n【示例】：本週最後一天("2019-01-30T01:00:00+08:00")【返回值】："2019-02-03"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "FirstDayOfLastWeek",
    "name": "上週第一天",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：返回指定日期的上週第一天，格式為"yyyy-MM-dd"，無參數則默認返回當前日期的上週第一天\n【返回值類型】：字符串(String)\n【示例】：上週第一天("2019-01-30T01:00:00+08:00")【返回值】："2019-01-21"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "LastDayOfLastWeek",
    "name": "上週最後一天",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：返回指定日期的上週最後一天，格式為"yyyy-MM-dd"，無參數則默認返回當前日期的上週最後一天\n【返回值類型】：字符串(System.String)\n【示例】：上週最後一天("2019-01-30T01:00:00+08:00")【返回值】："2019-01-27"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "FirstDayOfNextWeek",
    "name": "下週第一天",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：返回指定日期的下週第一天，格式為"yyyy-MM-dd"，無參數則默認返回當前日期的下週第一天\n【返回值類型】：字符串(String)\n【示例】：下週第一天("2019-01-30T01:00:00+08:00")【返回值】："2019-02-04"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "LastDayOfNextWeek",
    "name": "下週最後一天",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：返回指定日期的下週最後一天，格式為"yyyy-MM-dd"，無參數則默認返回當前日期的下週最後一天\n【返回值類型】：字符串(String)\n【示例】：下週最後一天("2019-01-30T01:00:00+08:00")【返回值】："2019-02-10"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "FirstDayOfMonth",
    "name": "本月第一天",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：返回指定日期的本月第一天，格式為"yyyy-MM-dd"，無參數則默認返回當前日期的本月第一天\n【返回值類型】：字符串(String)\n【示例】：本月第一天("2019-01-30T01:00:00+08:00")【返回值】："2019-01-01"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "LastDayOfMonth",
    "name": "本月最後一天",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：返回指定日期的本月最後一天，格式為"yyyy-MM-dd"，無參數則默認返回當前日期的本月最後一天\n【返回值類型】：字符串(String)\n【示例】：本月最後一天("2019-01-30T01:00:00+08:00")【返回值】："2019-01-31"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "FirstDayOfLastMonth",
    "name": "上月第一天",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：返回指定日期的上月第一天，格式為"yyyy-MM-dd"，無參數則默認返回當前日期的上月第一天\n【返回值類型】：字符串(String)\n【示例】：上月第一天("2019-01-30T01:00:00+08:00")【返回值】："2018-12-01"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "LastDayOfLastMonth",
    "name": "上月最後一天",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：返回指定日期的上月最後一天，格式為"yyyy-MM-dd"，無參數則默認返回當前日期的上月最後一天\n【返回值類型】：字符串(String)\n【示例】：上月最後一天("2019-01-30T01:00:00+08:00")【返回值】："2018-12-31"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "FirstDayOfNextMonth",
    "name": "下月第一天",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：返回指定日期的下月第一天，格式為"yyyy-MM-dd"，無參數則默認返回當前日期的下月第一天\n【返回值類型】：字符串(String)\n【示例】：下月第一天("2019-01-30T01:00:00+08:00")【返回值】："2019-02-01"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "LastDayOfNextMonth",
    "name": "下月最後一天",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：返回指定日期的下月最後一天，格式為"yyyy-MM-dd"，無參數則默認返回當前日期的下月最後一天\n【返回值類型】：字符串(String)\n【示例】：下月最後一天("2019-01-30T01:00:00+08:00")【返回值】："2019-02-28"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "FirstDayOfYear",
    "name": "本年第一天",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：返回指定日期的本年第一天，格式為"yyyy-MM-dd"，無參數則默認返回當前日期的本年第一天\n【返回值類型】：字符串(String)\n【示例】：本年第一天("2019-01-30T01:00:00+08:00")【返回值】："2019-01-01"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "LastDayOfYear",
    "name": "本年最後一天",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：返回指定日期的本年最後一天，格式為"yyyy-MM-dd"，無參數則默認返回當前日期的本年最後一天\n【返回值類型】：字符串(String)\n【示例】：本年最後一天("2019-01-30T01:00:00+08:00")【返回值】："2019-12-31"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "FirstDayOfLastYear",
    "name": "上年第一天",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：返回指定日期的上年第一天，格式為"yyyy-MM-dd"，無參數則默認返回當前日期的上年第一天\n【返回值類型】：字符串(String)\n【示例】：上年第一天("2019-01-30T01:00:00+08:00")【返回值】："2018-01-01"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "LastDayOfLastYear",
    "name": "上年最後一天",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：返回指定日期的上年最後一天，格式為"yyyy-MM-dd"，無參數則默認返回當前日期的上年最後一天\n【返回值類型】：字符串(String)\n【示例】：上年最後一天("2019-01-30T01:00:00+08:00")【返回值】："2018-12-31"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "FirstDayOfNextYear",
    "name": "下年第一天",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：返回指定日期的下年第一天，格式為"yyyy-MM-dd"，無參數則默認返回當前日期的下年第一天\n【返回值類型】：字符串(String)\n【示例】：下年第一天("2019-01-30T01:00:00+08:00")【返回值】："2020-01-01"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "LastDayOfNextYear",
    "name": "下年最後一天",
    "params": [
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：返回指定日期的下年最後一天，格式為"yyyy-MM-dd"，無參數則默認返回當前日期的下年最後一天\n【返回值類型】：字符串(String)\n【示例】：下年最後一天("2019-01-30T01:00:00+08:00")【返回值】："2020-12-31"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "GetDate",
    "name": "返回指定形式的日期",
    "params": [
      {
        "key": "format",
        "name": "格式串",
        "type": "string"
      },
      {
        "key": "date",
        "name": "日期時間",
        "type": "string"
      }
    ],
    "description": `【功能】：返回指定形式的日期，無參數則默認返回當前日期的指定格式日期\n【返回值類型】：字符串(String)\nDD：今天\tLD：昨天\tND：明天\tYY：本年\tLY：上年\tNY：下年\tMM：本月\tLM：上月\tNM：下月\nWD：星期幾\tWW：本週\tLW：上週\tNW：下週\tFDW：本週首日\tLDW：本週尾日\tFDLW：上週首日\tLDLW：上週尾日\nFDNW：下週首日\tLDNW：下週尾日\tFDM：本月首日\tLDM：本月尾日\tFDLM：上月首日\tLDLM：上月尾日\tFDNM：下月首日\tLDNM：下月尾日\nFDY：本年首日\tLDY：本年尾日\tFDLY：上年首日\tLDLY：上年尾日\tFDNY：下年首日\tLDNY：下年尾日\n【示例】：返回指定格式的日期("LD","2019-01-30T01:00:00+08:00")【返回值】："2019-01-29"`,
    "type": "DateTime",
    "keyFront": "DefaultFunction",
    "className": ""
  }
]